import { Navigate } from 'react-router-dom';
import { useAuthStore, UserType } from '../../stores/auth.store';

/**
 * Componente que redireciona para a rota correta baseado no tipo de usuário.
 * Usado na rota /banking para direcionar automaticamente para o dashboard do perfil.
 * 
 * - CUSTOMER → /banking/customer
 * - SUPPLIER → /banking/supplier
 * - EMPLOYEE → /banking/employee
 * - Super Admin → /banking/customer (fallback)
 */
export function BankingRedirect(): JSX.Element {
  const { user, isSuperAdmin } = useAuthStore();

  const getProfileRoute = (userType: UserType | undefined): string => {
    switch (userType) {
      case 'CUSTOMER':
        return '/banking/customer';
      case 'SUPPLIER':
        return '/banking/supplier';
      case 'EMPLOYEE':
        return '/banking/employee';
      default:
        // Super admin ou tipo não reconhecido vai para customer como fallback
        return '/banking/customer';
    }
  };

  // Se for super admin, pode escolher qualquer perfil, mas por padrão vai para customer
  if (isSuperAdmin()) {
    return <Navigate to="/banking/customer" replace />;
  }

  const targetRoute = getProfileRoute(user?.type);
  return <Navigate to={targetRoute} replace />;
}

export default BankingRedirect;
